//#region \0@oxc-project+runtime@0.151.0/helpers/esm/objectDestructuringEmpty.js
function e(e) {
	if (e == null) throw TypeError("Cannot destructure " + e);
}
//#endregion
export { e as default };
